export default "__VITE_ASSET__CfJHNqQa__"